import Vue from 'vue';
import i18n from "../../../i18n";

export default {
  async createEquipmentStatus({ commit }, payload) {
    return Vue.axios
      .post(Vue.$url("equipment-status"), payload)
      .then((rsp) => {
        Vue.$log.debug("equipment status created and saved under", rsp.data.id);
        commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'EquipmentStatus', 1: payload.description }), { root: true });
      })
  },

  async fetchEquipmentStatuses({ commit }, { pId, vId, pvId }) {
    let query = '?pId=' + (pId || '') + '&vId=' + (vId || '') + '&pvId=' + (pvId || '');
    return Vue.axios.get(Vue.$url("equipment-status" + query))
      .then((rsp) => commit("SET_EQUIPMENT_STATUSES", rsp.data));
  },

  async fetchNextSeqCode({ commit }, { pId, vId }) {
    Vue.$log.debug('loading equipment status next code for', pId, vId);
    let query = '?pId=' + (pId || '') + '&vId=' + (vId || '');
    return Vue.axios.get(Vue.$url("equipment-status/max-code" + query))
      .then((rsp) => {
        commit('SET_NEXT_SEQ_CODE', rsp.data);
        return rsp.data;
      })
  },

  async deleteEquipmentStatus({ commit }, payload) {
    Vue.$log.debug('trying to delete entity', payload.id);
    return Vue.axios
      .delete(Vue.$url("equipment-status/" + payload.id))
      .then(() => {
        commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }), { root: true });
      });
  },

  async updateEquipmentStatus({ commit }, payload) {
    return Vue.axios
      .put(Vue.$url("equipment-status/" + payload.id), payload)
      .then(() => {
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'EquipmentStatus', 1: payload.description }), { root: true });
      });
  },
}